import { _, allRoles, isAuthorized, lazyLoadView, piloteAndAuditor, requiresInternal, setNavL2 } from '@/router/routing'
import type { NavigationGuard, Route, RouteConfig } from 'vue-router'
import {
  HAVE_TO_COMPLETE_QUERY_PARAM,
  RUNBOOK_AGGREGATE_ID,
  RUNBOOKS_CONTRIBUTION_ROUTE_NAME,
  RUNBOOKS_ROUTE_NAME,
  RUNTASKS_CONTRIBUTION_ROUTE_NAME,
  RUNTASKS_ROUTE_NAME,
  RUNBOOK_LABEL_ROUTE_NAME,
} from '@/contexts/recurring-tasks/RecurringTasks.constants'

const redirectToDoToAllRunbooks: NavigationGuard = (to, from, next) => {
  if (to.name === RUNBOOKS_CONTRIBUTION_ROUTE_NAME && to.query[HAVE_TO_COMPLETE_QUERY_PARAM]) {
    next({ name: RUNTASKS_CONTRIBUTION_ROUTE_NAME, params: { id: RUNBOOK_AGGREGATE_ID }, query: to.query })
    return
  }
  setNavL2(to, from, next)
}

export const recurringTasksRoutes: RouteConfig = {
  path: '/runbooks',
  name: RUNBOOKS_ROUTE_NAME,
  component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbooksListView.vue')),
  meta: {
    title: _('Recurring tasks'),
    icon: 'clipboard-check',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    hidden_for_fp_assessment: true,
    doc_id: 'runbook',
    feature_id: 'RUNTASKS',
  },
  children: [
    {
      path: ':id',
      name: RUNTASKS_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbookView.vue')),
      meta: {
        title: null,
        icon: 'clipboard-check',
        is_authorized: (route: Route) => isAuthorized(route),
        hidden_for_fp_assessment: true,
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'my_runtasks',
      },
    },
    {
      path: 'label/list',
      name: RUNBOOK_LABEL_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbookView.vue')),
      meta: {
        title: null,
        icon: 'clipboard-check',
        is_authorized: (route: Route) => isAuthorized(route),
        hidden_for_fp_assessment: true,
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'my_runtasks',
      },
    },
  ],
}

export const recurringTasksContributionRoutes: RouteConfig = {
  path: 'runbooks',
  name: RUNBOOKS_CONTRIBUTION_ROUTE_NAME,
  component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbooksListView.vue')),
  beforeEnter: redirectToDoToAllRunbooks,
  meta: {
    title: _('Recurring tasks'),
    icon: 'clipboard-check',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: allRoles,
    requires_internal: () => requiresInternal(),
    hidden_for_fp_assessment: true,
    doc_id: 'runbook',
    nb_contribution: 'nb_runtasks',
  },
  children: [
    {
      path: ':id',
      name: RUNTASKS_CONTRIBUTION_ROUTE_NAME,
      component: () => lazyLoadView(import('@/contexts/recurring-tasks/RunbookView.vue')),
      meta: {
        title: null,
        icon: 'clipboard-check',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: allRoles,
        requires_internal: () => requiresInternal(),
        hidden_for_fp_assessment: true,
        doc_id: 'my_runtasks',
      },
    },
    // Former path of the recurring tasks contribution tab, kept for bookmarks.
    // Not an alias: an alias record has no meta and would break MainHeader tabs filtering.
    {
      path: '/contributions/runtasks',
      redirect: { name: RUNBOOKS_CONTRIBUTION_ROUTE_NAME },
    },
  ],
}
